var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKycVerifiedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C8.82441 22 6.69767 21.3549 4.88873 20.1462C3.07979 18.9375 1.66989 17.2195 0.83733 15.2095C0.00476613 13.1995 -0.213071 10.9878 0.211367 8.85401C0.635804 6.72022 1.68345 4.76021 3.22183 3.22183C4.76021 1.68345 6.72022 0.635804 8.85401 0.211367C10.9878 -0.213071 13.1995 0.00476613 15.2095 0.83733C17.2195 1.66989 18.9375 3.07979 20.1462 4.88873C21.3549 6.69767 22 8.82441 22 11C22 13.9174 20.8411 16.7153 18.7782 18.7782C16.7153 20.8411 13.9174 22 11 22ZM11 1.69231C9.15911 1.69231 7.35957 2.2382 5.82893 3.26094C4.29829 4.28368 3.1053 5.73735 2.40082 7.4381C1.69634 9.13886 1.51202 11.0103 1.87116 12.8158C2.2303 14.6214 3.11677 16.2798 4.41847 17.5815C5.72018 18.8832 7.37865 19.7697 9.18416 20.1288C10.9897 20.488 12.8611 20.3037 14.5619 19.5992C16.2627 18.8947 17.7163 17.7017 18.7391 16.1711C19.7618 14.6404 20.3077 12.8409 20.3077 11C20.3077 8.53145 19.3271 6.164 17.5815 4.41847C15.836 2.67294 13.4686 1.69231 11 1.69231Z",
    fill: "url(#paint0_linear_4107_4216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56492 15.53C9.46085 15.529 9.35799 15.5076 9.26223 15.4668C9.16646 15.4261 9.07967 15.3669 9.00682 15.2926L5.36533 11.6572C5.23616 11.5054 5.16907 11.3105 5.17746 11.1114C5.18585 10.9123 5.26912 10.7237 5.41061 10.5833C5.5521 10.4429 5.7414 10.361 5.94067 10.354C6.13994 10.347 6.33451 10.4155 6.48549 10.5456L10.123 14.181C10.2331 14.2917 10.3079 14.4324 10.3382 14.5854C10.3685 14.7384 10.3528 14.897 10.2932 15.0411C10.2335 15.1853 10.1326 15.3086 10.003 15.3956C9.87342 15.4826 9.72101 15.5293 9.56492 15.53Z",
    fill: "url(#paint1_linear_4107_4216)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86865 15.5294C9.70832 15.5295 9.55157 15.4819 9.4183 15.3928C9.28503 15.3036 9.18126 15.1768 9.12015 15.0285C9.05904 14.8801 9.04335 14.717 9.07508 14.5598C9.10681 14.4025 9.18453 14.2582 9.29836 14.1453L15.4421 8.00185C15.5939 7.84997 15.7998 7.76465 16.0144 7.76465C16.2291 7.76465 16.4349 7.84997 16.5867 8.00185C16.7385 8.15373 16.8238 8.35972 16.8238 8.57451C16.8238 8.7893 16.7385 8.99529 16.5867 9.14716L10.4389 15.2865C10.3645 15.3625 10.2758 15.4231 10.178 15.4648C10.0801 15.5064 9.97499 15.5284 9.86865 15.5294Z",
    fill: "url(#paint2_linear_4107_4216)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4107_4216",
    x1: 2.61236e-7,
    y1: 19.25,
    x2: 18.2875,
    y2: 2.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4107_4216",
    x1: 5.17676,
    y1: 14.8829,
    x2: 9.4797,
    y2: 10.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4107_4216",
    x1: 9.05908,
    y1: 14.5588,
    x2: 15.5135,
    y2: 8.63818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDAC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycVerifiedIcon);
export default __webpack_public_path__ + "static/media/kycVerifiedIcon.6ebeccc5ab6994794ef16cd890fca668.svg";
export { ForwardRef as ReactComponent };